<template>
    <section>
      <div class="row">
        <div id='loadingmessage'
          style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
          v-if="loading">
          <p style="position: absolute; color: White; top: 40%; left: 50%;">
            <img src="../../assets/loader.gif" />
          </p>
        </div>
        <div class="col-12 grid-margin">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Edit Profile &nbsp;<span> <button v-b-modal.modal-footer-sm1 class="btn btn-light px-0 py-0 ">Change
                  Password<i class="fa fa-edit"></i></button></span></h4>
              <form class="form-sample" @submit="onSubmit">
                  <div class="row">
                  <div class="col-md-6">
                    <b-form-group horizontal label="Name">
                      <b-form-input required type="text" v-model="name"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="User Name">
                      <b-form-input required type="text" v-model="username"></b-form-input>
                    </b-form-group>
                  </div>n
  
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group horizontal label="Phone">
                      <b-form-input required type="text" v-model="phone"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="Email">
                      <b-form-input required type="email" v-model="email"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="Organization">
                      <b-form-input type="text" v-model="organization"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="Occupation">
                      <b-form-input type="text" v-model="occupation"></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row ">
                  <div class="col-md-3 form-group" style="font-size:16px!important">
                    <label for="exampleInputEmail1">Please upload Image</label>
                    <br />
  
                    <input type="file" class="images" accept="image/*" id="file" ref="file"
                      v-on:change="handleFileUpload()" />
                      <p v-if="image">{{data.photo}}</p>
                  </div>
                  <div class="col-md-2">
                    <div width="80px" height="80px"  id="preview">
                      <img width="100%" height="100%" :src="image" />
                    </div>
                  </div>
                </div>
                <hr>
                <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
              </form>
              <b-modal id="modal-footer-sm1" title button-size="sm">
                <form @submit="onsubmit1">
                    <h4 style="font-size:20px!important">Change My Password</h4>
                    <div class="pb-3 pt-3">
                        <label>Old Password</label>
                        <input v-model="oldpassword" type="password" required class="pt-2 pb-2"
                            style="color:black!important;width:100%!important;">
                        <!-- <span toggle="#password-field" class="fa fa-fw fa-eye field-icon toggle-password"></span> -->
                    </div>
  
                    <div class="pb-3">
                        <label>New Password</label>
                        <input v-model="password" type="password" required class="pt-2 pb-2"
                            style="color:black!important;width:100%!important;" />
                    </div>
                    <div class="d-flex justify--center mt-3">
                        <button type="submit" class=" pt-2 pb-2 btn btn-success"
                            style="width:100%!important;">Submit</button>
                    </div>
  
                </form>
            </b-modal>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
    import axios from "axios";
    export default {
      name: "editadmin",
      props: ['id'],
      data: () => {
        return {
          username: '',
          name: '',
          password: '',
          oldpassword:'',
          phone: '',
          email: '',
          organization: '',
          occupation: '',
          image: null,
          file: '',
        
          loading: false,
  
        };
      },
      mounted: function () {
        this.getDetails()
      },
      methods: {
        resetForm() {
          this.username = ''
          this.name = ''
          this.password = ''
          this.phone = ''
          this.email = ''
          this.occupation = ''
          this.organization = ''
          this.error = ''
          this.file = null
          this.image = null
        },
        getDetails() {
          this.loading = true;
          var data1 = {}
  
          
          axios({
            method: "GET",
            url: "/user/profile/",
            params:{'id':this.id,'token':localStorage.getItem("token")},
            
  
          })
            .then(response => {
              this.loading = false;
              this.isstat = response.data.status
              if (response.data.status === true) {
                this.data = response.data.data;
                this.username = response.data.data.username
                this.name = response.data.data.name
                this.password =response.data.data.password
                this.phone = response.data.data.phone
                this.email =response.data.data.email
                this.occupation =response.data.data.occupation
                this.organization = response.data.data.organization
                if(response.data.data.photo!=null)
              {
                this.image = 'http://13.232.14.77/u/'+response.data.data.photo;
              }
                // var temp={}
                // for(var j=0;j<response.data.data.image.length;j++)
                // {
                //   var ty=response.data.data.image[j]
                //   temp.push(ty)
                // }
                this.loading = false;
              } else if (response.data.status === false) {
                this.loading = false;
              }
            })
            .catch(e => {
              this.loading = false;
              alert('Something went wrong')
              this.errors.push(e);
              this.msg = "failed";
            });
        },
  
        onSubmit(evt) {
          evt.preventDefault();
          var edit = {};
          edit['username'] = this.username
          edit['name'] = this.name
          edit['password'] = this.password
          edit['phone'] = this.phone
          edit['email'] = this.email
          edit['occupation'] = this.occupation
          edit['organization'] = this.organization
  edit['id']=this.id
          edit['x-auth-token'] = localStorage.getItem("token")
          axios({
            method: 'post',
            url: '/user/completeprofile',
            data: edit,
  
          })
            .then(response => {
              this.msg = response.data.msg;
              this.id = response.data._id;
              this.loading = "false";
              if (response.data.status === true) {
                this.id1 = response.data.data._id
                let formData = new FormData();
                formData.append("token", localStorage.getItem("token"));
                formData.append("id", this.id1);
                formData.append("image", this.file);
                this.loading = true;
  
                axios({
                  method: "post",
                  url: "/user/imageupload",
                  data: formData,
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                })
                  .then(response => {
                    this.resetForm()
                    alert('Admin Details edited Successfully')
                    this.$router.push({ path: "/adminslist" });
                    this.loading = false
                  })
                  .catch(e => {
                    this.loading = false
                    this.error = e.response.data.msg
                    alert('Admin Details edited Successfully')
                  })
              }
              if (response.data.status === false) {
                this.loading = false
  
                alert('Please try again')
              }
            })
            .catch(err => {
              this.loading = false
  
              alert('Please try again')
            });
        },
  
        handleFileUpload() {
          this.file = this.$refs.file.files[0];
          this.image = URL.createObjectURL(this.file);
        },
        onsubmit1(evt) {
                  this.visible = true
  
                  var data = {}
  
                  data['oldpassword'] = this.oldpassword
                  data['password'] = this.password
                  data['id'] = this.id
                  data['x-auth-token'] = localStorage.getItem("token")
  
                  evt.preventDefault()
                  axios({
                      method: 'post',
                      url: '/user/completeprofile',
                      data: data,
  
                  })
                      .then(response => {
                          this.visible = false
                          this.status = response.data.status
                          this.msg = response.data.msg
                          if (response.data.status === true) {
                             alert('Password Changed Successfully')
                          } else {
                              alert('Please Try Again')
                          }
                      })
                      .catch(err => {
                          if (err.response.data.status === false) { this.msg = 'Please Try Again' }
                      })
              },
          },
    };
  </script>
  
<style >
    .card-body>>>table>tbody>tr>td {
        cursor: pointer;
    }

    .btn.btn-sm,
    .btn-group-sm>.btn {
        display: none !important;
    }
</style>